import gql from 'graphql-tag';

export const UPLOAD_ADS = gql`
  mutation UploadAds(
    $articleId: ID!
    $creativeIds: [Int!]!
    $audienceIds: [Int!]
    $startTime: String!
    $newFbCampaign: Boolean!
    $uploadSourceType: UploadSourceTypeEnum!
  ) {
    uploadAds(
      articleId: $articleId
      creativeIds: $creativeIds
      audienceIds: $audienceIds
      startTime: $startTime
      newFbCampaign: $newFbCampaign
      uploadSourceType: $uploadSourceType
    ) {
      longRunningJob {
        id
        progress
      }
      audience {
        id
        lastUpload
      }
      errors
    }
  }
`;
